import $ from 'jquery';

const searchFiles = {
    settings: {
        input: document.querySelector('.data-search input'),
        title: new Set(),
        filesContainer: document.querySelectorAll('.files-content')
    },

    init: () => {
        const btn = document.querySelector('.data-search button');
        const input = document.querySelector('.data-search input');
        const displayValueContainer = document.querySelector('.data-search__value');
        btn?.addEventListener('click', searchFiles.validateInput);
        input?.addEventListener('keyup', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                searchFiles.validateInput(e)
            }
        });
        displayValueContainer?.addEventListener('click', searchFiles.reset);
        searchFiles.appendTitleBeforeFile();
    },

    validateInput: () => {
        const searchValue = searchFiles.settings.input.value.toLowerCase();

        if ( searchValue.length >= 2 ) {
            searchFiles.searchForFiles(searchValue)
            searchFiles.displaySearchValue(searchValue);
        }
    },

    appendTitleBeforeFile: () => {
        const filesContent = document.querySelectorAll('.files-content');
        if ( ! filesContent.length) {
            return;
        }
        let flagArchive = true;
        let flagCurrent = true;
        filesContent.forEach( (section) => {
            flagArchive = true;
            flagCurrent = true;
            const divCurrent = document.createElement('div');
            const divArchive = document.createElement('div');
            divCurrent.innerText = 'Aktualne';
            divCurrent.classList.add('file-row__title', 'file-row__title--current')
            divArchive.innerText = 'Archiwalne';
            divArchive.classList.add('file-row__title', 'file-row__title--archive')
            const sectionFiles = section.querySelectorAll('.file-row')
            if ( ! sectionFiles.length) {
                return;
            }
            sectionFiles.forEach( (file, key) => {

                if (file.classList.contains('file-row--archive') && flagArchive) {
                    file.prepend(divArchive)
                    flagArchive = false;
                }

                if (file.classList.contains('file-row--current') && flagCurrent) {
                    file.prepend(divCurrent)
                    flagCurrent = false;
                }

            } )
        } )

    },

    searchForFiles: (searchValue) => {
        const fileNames = document.querySelectorAll('.file-row__name');
        searchFiles.settings.title.clear();

        fileNames.forEach( fileName => {
            const fileNameString = fileName.textContent.toLowerCase();
            const searchResult = fileNameString.search(searchValue);
            if ( searchResult > 0 ) {
                fileName.classList.add('var_search');
                fileName.parentElement.classList.add('active')
            } else {
                fileName.classList.remove('var_search');
                fileName.parentElement.classList.remove('active')
            }
        } )

        document.querySelector('.data-search__output').classList.add('searching')
    },

    toggleNavParent: (parentClass, activeClass) => {
        const navParents = document.querySelectorAll(`.${parentClass}`);

        navParents.forEach( navParent => {
            const navParentId = navParent.getAttribute('data-toggle-trigger');

            if ( searchFiles.settings.title.has(navParentId) ) {
                navParent.classList.add(`${activeClass}`);
                document.querySelector(`[data-toggle-content="${navParentId}"]`).classList.add('search_value')

            } else {
                navParent.classList.remove(`${activeClass}`);
                document.querySelector(`[data-toggle-content="${navParentId}"]`).classList.remove('search_value')
            }
        } )

        const currentActiveTab = document.querySelector('.files-content.active');
        currentActiveTab?.classList.remove('active');

        let dataActiveIndex = document.querySelector('.data-search__output').getAttribute('data-active-index')
        document.querySelector(`[data-content-index="${dataActiveIndex}"]`).classList.add('active')
    },

    displaySearchValue: (searchValue) => {
        const valueContainer = document.querySelector('.data-search__value');
        const p = document.querySelector('.data-search__value p');

        valueContainer.classList.add('data-search__value--display')
        if ( p.textContent.length == 0 ) {
            p.textContent = searchValue;
        } else {
            p.textContent = '';
            p.textContent = searchValue;
        }
    },


    reset: () => {
        const valueContainer = document.querySelector('.data-search__value');
        const p = document.querySelector('.data-search__value p');

        valueContainer.classList.remove('data-search__value--display')
        p.textContent = '';

        document.querySelectorAll('.var_search').forEach(el => el.classList.remove('var_search'));
        document.querySelectorAll('.var_search').forEach(el => el.parentElement.classList.remove('active'));

        searchFiles.settings.input.value = '';

        document.querySelectorAll('.files-content').forEach(el => el.classList.remove('search_value'));
        document.querySelector('.data-search__output').classList.remove('searching')
    }
}

export default searchFiles;